<template>
  <div class="row">
    <div class="top-bar vd-top-bar">
      <p v-if="camera.id">{{ camera.name }}</p>
      <burger/>
    </div>

    <div class="container-main right-container-video">
      <!-- ATTENDANCE TRACKING SMALL -->
      <div class="vd-attendance-tracking">
        <div class="row vd-logs-top">
          <p>Logs</p>
          <div class="dropdown" style="float:left;">
            <button class="dropbtn video-dropdown">
              <p>Filter &nbsp;<i class="fas fa-caret-down"></i></p>
            </button>
            <div class="dropdown-content dropdown-content-dashboard vd-dropdown">
              <a href="#" @click="updateCategory()">All</a>
              <a href="#" @click="updateCategory(1)">Unidentified</a>
              <a href="#" @click="updateCategory(2)">Identified</a>
            </div>
          </div>
        </div>
        <div class="row attendance-tracking-small" id="items-container">
          <a class="vd-item-link" v-for="item in items" :key="item.id" :href="`/events?user_id=${item.user.id}`" v-if="(status == null || item.category == status)">
            <div class="row item vd-item">
              <div class="col-md-3 avatar avatar-small">
                <p>CAM {{ item.camera_id }}</p>
                <img :src="item.image_crop_path" class="identified-border" alt="" v-if="item.category == 2">
                <img :src="item.image_crop_path" class="unidentified-border" alt="" v-else>
              </div>
              <div class="col-md-9 vd-person-data" v-if="item.category == 2">
                <p class='identified-status vd-identified' v-if="item.user">
                  {{ item.user.first_name }} {{ item.user.last_name }}
                </p>
                <br>
                <p class="vd-start_time">{{ moment(item.time_start).format('MMM DD h:mm A') }} </p>
                <p class="vd-start_time">- {{ moment(item.time_end).format('MMM DD h:mm A') }}</p>
                <p class="vd-id-label">Person ID</p>
                <p class="vd-id">&nbsp; {{ item.user.id }}</p>
              </div>

              <div class="col-md-8 vd-person-data" v-else>
                <p class='unidentified-status'>
                  Unidentified
                </p>
                <p class="vd-start_time">{{ moment(item.time_start).format('MMM DD h:mm A') }}</p>
                <p class="vd-start_time">{{ ' - ' + moment(item.time_end).format('MMM DD h:mm A') }}</p>
                <p class="vd-id-label">Person ID</p>
                <p class="vd-id">&nbsp; {{ item.user.id }}</p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="row right-container-video">
      <!-- IMAGES CONTAINER -->
      <div class="video-dashboard-container">
        <div class="dashboard-grid-container">
          <div class="vd-footage-conatiner-box vid-footage-box-1">
            <div class="footage-labels">
              <p>HD</p>
              <p>{{ camera.name }}</p>
              <p><img src="../../.././assets/images/Thermo .svg" alt=""></p>
            </div>
            <div class="row row-footage-2" style="margin-right: 0; margin-left: 0;" v-if="camera.id">
              <div class="col vd-footage-box vd-footage-box-1">
                <img style="-webkit-user-select: none;" :src="`${camera.path}`">
              </div>
              <div class="col vd-footage-box vd-footage-box-2">
                <img style="-webkit-user-select: none;" :src="`${camera.path}/thermal`">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Burger from '@/components/Burger';

  export default {
    name: 'VideoCam',
    components: {
      Burger
    },
    data() {
      return {
        id: this.$router.currentRoute.params.id,
        camera: {},
        items: {},
        schedule: null,
        status: null,
        loading: false
      };
    },
    computed: {
      url() {
        return this.axios.defaults.baseURL;
      },
    },
    mounted() {
      this.getCamera();
      this.getItems();

      this.schedule = setInterval(() => this.getItems(), 5000);
    },
    beforeDestroy() {
      clearInterval(this.schedule);
    },
    methods: {
      updateCategory(status = null) {
        this.status = status;
        this.getItems();
      },
      getParams() {
        let data = { compact: '1' };

        data['camera_ids'] = [this.id];

        if (this.status != null) {
          data['category'] = this.status;
        }

        return data;
      },
      getItems() {
        this.axios.get(`/events`, { params: this.getParams() })
          .then((response) => this.items = response.data.events);
      },
      getCamera() {
        if (this.loading) {
          return;
        }

        let data = {
          camera_id: this.id
        };

        if (this.status) {
          data.status = this.status;
        }

        this.loading = true;
        this.axios.get(`/camera`, { params: data })
          .then((response) => {
            this.loading = false;
            this.camera = response.data;
          });
      },
    }
  }
</script>

<style scoped>
  .row.right-container-video {
    width: 100%;
  }
</style>
